import React, { useRef, useState } from "react";
import axiosClient from "../../axios";

const SearchDropDown = ({ queryText, getSelectedInspection }) => {
  const timeoutRef = useRef(null);
  const [searchResults, setSearchResults] = useState([]);
  const [query, setQuery] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);

    clearTimeout(timeoutRef.current);
    if (value.trim() === "") {
      setSearchResults([]);
      setShowDropdown(false);
      return;
    }

    timeoutRef.current = setTimeout(() => {
      handleSearch(value);
    }, 500);
  };

  const handleSearch = async (value) => {
    try {
      const response = await axiosClient.get("/inspections/search_scheduled", {
        params: { search: value },
      });
      const results = response.data.data;
      setSearchResults(results);
      setShowDropdown(results.length > 0);
    } catch (error) {
      console.error("Error fetching data:", error);
      setSearchResults([]);
      setShowDropdown(false);
    }
  };

  const handleSelect = (item) => {
    setQuery(`${item.audit_policy_holder} - ${item.audit_broker_name}`);
    setShowDropdown(false);
    if (item.id !== undefined) {
      getSelectedInspection(item);
    }
  };

  return (
    <div className="w-1/2 mx-auto relative">
      <input
        type="text"
        value={query}
        onChange={handleChange}
        placeholder={queryText}
        className="w-full p-2 rounded-2xl border border-gray-300 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      />
      {showDropdown && (
        <ul className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
          {searchResults.map((item) => (
            <li
              key={item.id}
              onClick={() => handleSelect(item)}
              className="px-4 py-2 hover:bg-blue-100 cursor-pointer text-black"
            >
              {item.audit_policy_holder} - {item.audit_broker_name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchDropDown;
